import React, { useState, useEffect } from 'react';
import formatDuration from '../utils/formatDuration';

/**
 * Live Uptime Component that updates every second
 * Shows how long the task has been in the system since creation
 */
export default function LiveUptime({ task, serverTimeOffset }) {
    const [, setTick] = useState(0);

    useEffect(() => {
        // Always update uptime every second to show system presence time
        const interval = setInterval(() => {
            setTick(prev => prev + 1);
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    if (!task.startTime) return <span className="text-xs text-admin_text_secondary">-</span>;

    // Calculate uptime: time since task was created (startTime) until now
    const currentServerTime = Date.now() + (serverTimeOffset || 0);
    const uptime = currentServerTime - task.startTime;

    return <span className="text-xs text-admin_text">{formatDuration(uptime)}</span>;
}
